import { render, staticRenderFns } from "./basic-information.vue?vue&type=template&id=7f5c288e"
import script from "./basic-information.vue?vue&type=script&lang=js"
export * from "./basic-information.vue?vue&type=script&lang=js"
import style0 from "./basic-information.vue?vue&type=style&index=0&id=7f5c288e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports